module.exports = __webpack_public_path__ + "img/logo.a1ac837c.png";